
const pieces = [
  {
    no: "No. I",
    name: "Argent Brûlé",
    translation: "— “Burnt Silver”",
    image: "//maisonaldour.com/cdn/shop/t/19/assets/IMG_3860.jpeg?v=180919572582139194471778436305",
    link: "/products/argent-brule",
    desc: "Solid steel sheet tiles, individually patinated and laid against a timber base. The surface holds a memory of storm-light: silver above, drifting through ash and graphite into a dense, charcoaled base."
  },
  {
    no: "No. II",
    name: "Aurum Cendre",
    translation: "— “Ash Gold”",
    image: "//maisonaldour.com/cdn/shop/t/19/assets/IMG_3863.jpeg?v=79722258072474496381778436305",
    link: "/products/aurum-cendre",
    desc: "Champagne-bright at the summit, descending through honeyed brass into a low burn of rose-gold and ember. The surface is foxed with delicate spotting — the natural script of metal as it learns to age."
  },
  {
    no: "No. III",
    name: "Cuivre Sanguine",
    translation: "— “Blood Copper”",
    image: "//maisonaldour.com/cdn/shop/t/19/assets/IMG_3868.jpeg?v=171997179088652814201778436305",
    link: "/products/cuivre-sanguine",
    desc: "A descent through fire. Solid brass tiles drawn out into copper through vinegar and salt — yielding rose, garnet and dried-rose pigments. The lower tiles glow as if lit from within."
  },
  {
    no: "No. IV",
    name: "Cuivre Marée",
    translation: "— “Tidal Copper”",
    image: "//maisonaldour.com/cdn/shop/t/19/assets/cuivre_maree.jpeg?v=128144263754175361941778436305",
    link: "/products/cuivre-maree",
    desc: "Bone-pale at the summit, descending through warm sand into turquoise and a deep, weathered verdigris at the base. A study in tidal chemistry."
  },
  {
    no: "No. V",
    name: "Bleu Nocturne",
    translation: "— “Night Blue”",
    image: "//maisonaldour.com/cdn/shop/t/19/assets/bleu_nocturne.jpeg?v=49409682970065841801778436305",
    link: "/products/bleu-nocturne",
    desc: "Rose-bone at the summit, descending through honeyed brass and oxidised teal into a profound, near-lacquered midnight blue at the base."
  }
];
const tabs=document.getElementById('pieceTabs');
const els={no:document.getElementById('pieceNo'),name:document.getElementById('pieceName'),translation:document.getElementById('pieceTranslation'),image:document.getElementById('pieceImage'),caption:document.getElementById('pieceCaption'),desc:document.getElementById('pieceDesc')};
function setPiece(i){const p=pieces[i];els.no.textContent=p.no;els.name.innerHTML='<em>'+p.name+'</em>';els.translation.textContent=p.translation;els.image.src=p.image;els.image.alt=p.name+' patinated metal artwork';els.caption.textContent=p.no+' — '+p.name;els.desc.textContent=p.desc;
  const acquire = document.getElementById('pieceAcquire');
  if (acquire && p.link) acquire.href = p.link;document.querySelectorAll('#pieceTabs button').forEach((b,idx)=>b.classList.toggle('active',idx===i));}
pieces.forEach((p,i)=>{const b=document.createElement('button');b.textContent=p.name;b.onclick=()=>setPiece(i);tabs.appendChild(b)});setPiece(0);
const nav=document.getElementById('nav');window.addEventListener('scroll',()=>nav.classList.toggle('scrolled',scrollY>50));
const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible')}),{threshold:.08});document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
